module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODciIGhlaWdodD0iMTU2IiB2aWV3Qm94PSIwIDAgMTg3IDE1NiI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9IiMwMDg0RkYiIHN0cm9rZS1vcGFjaXR5PSIuMzA3IiBvcGFjaXR5PSIuOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjU3MSAtMzAuMTQzKSI+PGNpcmNsZSBjeD0iLTExLjUiIGN5PSI4MC41IiByPSI1MC41IiBvcGFjaXR5PSIuNCIvPjxjaXJjbGUgY3g9IjIyMy41IiBjeT0iMTY1LjUiIHI9Ijk1LjUiIG9wYWNpdHk9Ii40Ii8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/service-bg-4.svg
// module id = 86
// module chunks = 35783957827783 79611799117203 85929988179075 182101406987512